import ReactGA4 from "react-ga4";

const InitializeGoogleAnalytics = () => {
  // Initialize GA4
  ReactGA4.initialize("G-N24SPES9QJ");
};

const TrackGoogleAnalyticsEvent = (category, action, label) => {
  // Send GA4 Event
  ReactGA4.event({
    category: category,
    action: action,
    label: label,
  });
};

export default InitializeGoogleAnalytics;
export { InitializeGoogleAnalytics, TrackGoogleAnalyticsEvent };
